import React, { useRef, useState } from "react";
import ReactApexChart from "react-apexcharts";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useSelector } from 'react-redux';

const EducationByGenderChart = () => {
  const EducationFilter = useSelector(state => state.dashboard?.noEducationCount) || {
    male: {},
    female: {}
  };

  const [showModal, setShowModal] = useState(false);
  const chartRef = useRef(null);

  const options = {
    chart: {
      type: "bar",
      height: 350,
      stacked: false,
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "70%",
        endingShape: "rounded",
      },
    },
    grid: {
      show: false,
      xaxis: { lines: { show: false } },
      yaxis: { lines: { show: false } },
    },
    dataLabels: {
      enabled: true,
      formatter: (val) => val + "%",
      style: {
        fontSize: "14px",
        fontWeight: "bold",
        colors: ["#ffffff"],
      },
    },
    xaxis: {
      categories: ["6-11", "12-16", "17-18", "19-30", "31-49", "50+"],
      labels: {
        style: { fontSize: "13px" },
      },
    },
    yaxis: {
      title: { text: "%" },
      max: 70,
    },
    legend: { position: "bottom" },
    fill: {
      type: "gradient",
      gradient: {
        shade: "dark",
        type: "horizontal",
        shadeIntensity: 0.5,
        inverseColors: false,
        opacityFrom: 0.9,
        opacityTo: 1,
        stops: [0, 100],
      },
    },
    colors: ["#F56217", "#41295a"],
    responsive: [
      {
        breakpoint: 768,
        options: {
          plotOptions: {
            bar: { columnWidth: "40%" },
          },
          dataLabels: {
            style: { fontSize: "12px" },
          },
          xaxis: {
            labels: { style: { fontSize: "11px" } },
          },
        },
      },
    ],
  };

  const ageGroups = ["6-11", "12-16", "17-18", "19-30", "31-49", "50+"];
  const maleData = ageGroups.map(age => EducationFilter.male?.[age] ?? 0);
  const femaleData = ageGroups.map(age => EducationFilter.female?.[age] ?? 0);

  const series = [
    {
      name: "% Male with No Education",
      data: maleData,
    },
    {
      name: "% Female with No Education",
      data: femaleData,
    },
  ];

  const exportPDF = async () => {
    if (!chartRef.current) return;

    const canvas = await html2canvas(chartRef.current, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("landscape", "pt", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 40, pdfWidth, pdfHeight);
    pdf.save("no-education-by-gender.pdf");
  };

  return (
    <>
      <div className="bg-white rounded-lg shadow-md flex flex-col h-full w-full">
        <div className="border-b px-4 py-3 rounded-t-lg gradiant2">
          <h3 className="text-[0.875rem] tracking-[0.0625rem] text-[#856800] font-bold uppercase">
            No Education by Gender
          </h3>
        </div>
        <div
          className="px-4 py-4 w-full cursor-pointer"
          onClick={() => setShowModal(true)}
          title="Click to view fullscreen"
        >
          <ReactApexChart options={options} series={series} type="bar" height={350} width={570} />
        </div>
      </div>

      {showModal && (
        <div className="fixed inset-0 z-[9999] bg-white flex flex-col items-center justify-center">
          <button
            className="absolute top-4 left-6 text-3xl font-bold text-gray-600 hover:text-black"
            onClick={() => setShowModal(false)}
          >
            ×
          </button>

          <div className="absolute top-4 right-6">
            <div className="relative inline-block text-left">
              <div className="origin-top-right absolute right-0 mt-2 w-40 gradiant2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50">
                <div className="py-1">
                  <button
                    onClick={exportPDF}
                    className="ww-full px-4 py-2 text-sm  text-[#856800] font-bold text-center"
                  >
                    Export PDF
                  </button>
                </div>
              </div>
            </div>
          </div>

          <h2 className="text-xl font-semibold mb-4 text-[#856800] mt-8">
            No Education by Gender
          </h2>

          <div ref={chartRef} className="w-[90vw] h-[80vh] flex items-center justify-center">
            <ReactApexChart
              options={options}
              series={series}
              type="bar"
              height={500}
              width={1200}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default EducationByGenderChart;
